import React from "react";

import cn from "classnames";

import { boxForwardRef } from "../../../../../helpers/common/Box/Box";
import { Content } from "../../../../Content";
import { createDisplayNameForButtonCellElement } from "../../utils/getDisplayName";
import { createTestIdForButtonCellElement } from "../../utils/getTestId";

import type { BoxComponentWithDefault } from "../../../../../helpers/common/Box/Box";
import type { OmitOfUnion } from "../../../../../types/react";
import type { ContentTextProps } from "../../../../Content/Content/components/Text/ContentText";

import classes from "./ButtonCellLabel.styl";

export type ButtonCellTextProps = OmitOfUnion<
    ContentTextProps,
    | "textCase"
    | "underline"
    | "strikethrough"
    | "lineHeight"
    | "truncateStyle"
    | "asList"
    | "quote"
    | "italic"
>;

const LABEL_TEST_ID = createTestIdForButtonCellElement("label");

export const ButtonCellLabel = boxForwardRef<
    BoxComponentWithDefault<"span", ButtonCellTextProps, "className">
>(({ children, size = "17", customVarsStyles, ...props }, ref) => {
    return children ? (
        <Content.Text
            {...props}
            size={size}
            data-tsid={LABEL_TEST_ID}
            customVarsStyles={cn(customVarsStyles, classes["label"])}
            ref={ref}
        >
            {children}
        </Content.Text>
    ) : null;
});

ButtonCellLabel.displayName = createDisplayNameForButtonCellElement("Label");

export default ButtonCellLabel;
